export class EventCancelledModal {
  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
  }
}
